
<footer class="bg-black text-white pt-12 px-8 m-0">
    <div
      class="container mx-auto max-w-6xl grid grid-cols-1 md:grid-cols-3 gap-8"
    >
      <!-- Company Section -->
      <div>
        <h3 class="text-lg font-bold mb-4 flex items-center space-x-2">
          <img src="assets/hypenation-white-logo.svg" alt="hypenation logo">
        </h3>
        <!-- <p class="text-sm mb-4">
          Lorem ipsum dolor sit amet consectetur adipisicing elit aliquam.
        </p> -->
        <div class="flex space-x-4 text-2xl">
          <a href="#" class="hover:text-black"><i class="fab fa-facebook"></i></a>
          <a href="#" class="hover:text-black"><i class="fab fa-twitter"></i></a>
          <a href="#" class="hover:text-black"
            ><i class="fab fa-instagram"></i
          ></a>
          <a href="#" class="hover:text-black"><i class="fab fa-linkedin"></i></a>
          <a href="#" class="hover:text-black"><i class="fab fa-youtube"></i></a>
        </div>
      </div>
  
      <!-- Important Resources -->
      <div>
        <h3 class="text-lg font-bold mb-4 text-white">Important Resources</h3>
        <ul class="text-sm space-y-2">
          <li><a href="https://about.hypenation.co.zw/about" class="hover:underline">About Us</a></li>
          <li><a href="https://about.hypenation.co.zw/contact" class="hover:underline">Contact Us</a></li>
          <li><a href="https://about.hypenation.co.zw/services" class="hover:underline">Services</a></li>
          <li><a href="/terms-conditions" class="hover:underline">Terms and Conditions</a></li>
          <li><a href="https://hypenation.pixieset.com/" class="hover:underline">Gallery</a></li>
          <li><a [href]="organiserLoginUrl" target="_blank" rel="noopener noreferrer" class="hover:underline">Organiser Login</a></li>
        </ul>
      </div>
  
      <!-- Contact Us Section -->
      <div>
        <h3 class="text-lg font-bold mb-4 text-white">Contact Us</h3>
        <ul class="text-sm space-y-2">
          <li>
            <a href="tel:+263777980062" class="hover:underline"
              >+263 777 980 062</a
            >
          </li>
          <li>
            <a href="tel:+263719591300" class="hover:underline"
              >+263 719 591 300</a
            >
          </li>
          <li>
            <a href="mailto:admin@hypenation.co.zw" class="hover:underline"
              >admin&#64;hypenation.co.zw</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="border-t border-gray-300 mt-8 p-8">
      <p class="text-center"> Designed and developed by <a href="/hobbsTechsolutely" class="text-gray-500 font-bold">HobbsTechsolutely</a>. A partnership between <a  class="text-gray-500 font-bold" href="https://hobbstech.co.zw/" target="_blank">Hobbstech</a>  and <a href="https://techsolutely.co.zw/"  class="text-gray-500 font-bold">Techsolutely</a> </p>
    </div>
  </footer>
  